declare var Stripe: any;
declare var StripePublicKey: string;
declare var cardNumberElement: any;
declare var cardExpiryElement: any;
declare var cardCvcElement: any;
declare var stripe: any;

function CreateUser() {
    /*
    1. validate data
    2. register card with stripe
    3. remove card data from form and submit to backend, optionaly imei device
      1. validate data
      2. register user (and credit card)
      3. register device
    4. redirect user
    */

    var submitButton = $("#registerSubmit");
    submitButton.prop("disabled", true);

    let newUser: CustomerAPI.WebUserRegisterInfo = new CustomerAPI.WebUserRegisterInfo();
    newUser.name = $("#name").val();
    newUser.email = $("#email").val();
    newUser.imei = $("#imei").val();

    var pass1 = $("#password").val();
    var pass2 = $("#confirm").val();
    if (pass1 != pass2)
    {
        submitButton.prop("disabled", false);
        Alert.OpenError(localizer["RegisterPasswordNotEqualTitle"], localizer["RegisterPasswordNotEqualMessage"]);
        return false;
    }
    newUser.password = pass1;

    CustomerAPI.subscriptionsAPI.getSetupIntent().done((data, textStatus, xhr) => {

        var clientSecret = data;

        submitButton.html(localizer["PaymentValidating"] + ' <i class="fa fa-spinner fa-pulse"></i>').prop('disabled', true);
        stripe.handleCardSetup(
            clientSecret, cardNumberElement
        ).then(function (result) {
            if (result.error) {
                Alert.OpenError("Error", result.error.message);
                submitButton.html(localizer["RegisterSubmit"]).prop('disabled', false);
            } else {
                newUser.paymentMethodId = result.setupIntent.payment_method;
                CustomerAPI.customerAPI.register(newUser, () => CreateLogin(newUser.email, pass1), (ex, reason) => {
                    submitButton.prop("disabled", false);
                    Alert.OpenError(localizer["RegisterCreateFailed"], ex)
                });
            }
        });
    });

    //var expiry = $('#cardExpiry').payment('cardExpiryVal');

    //var stripeData = {
    //    number: $('#cardNumber').val().replace(/\s/g, ''),
    //    cvc: $('#cardCVC').val(),
    //    exp_month: expiry.month,
    //    exp_year: expiry.year,
    //};

    //sendCardDataToStripe(stripeData, (error, data) => {
    //    if (error) {
    //        submitButton.prop("disabled", false);
    //        Alert.OpenError(localizer["RegisterCreateFailed"], error);
    //        return;
    //    }

    //    newUser.stripeToken = data.id; 

    //});
    

    return false;
}

function CreateLogin(usernam: string, password: string)
{
    CustomerAPI.login(usernam, password, () => window.location.href = "/my/devices", (ex, reason) => Alert.OpenError(localizer["RegisterLoginFailedTitle"], localizer["RegisterLoginFailedMessage"]));
}

/* If you're using Stripe for payments */
function sendCardDataToStripe(stripeData: any, callback: (error: string, data: any) => void) {
    Stripe.setPublishableKey(StripePublicKey);

    Stripe.card.createToken(stripeData, function stripeResponseHandler(status, response) {
        callback(response.error, response);
    });

    /* Visual feedback */
    //$form.find('.subscribe').html(localizer["PaymentValidating"] + ' <i class="fa fa-spinner fa-pulse"></i>').prop('disabled', true);
    
    /* Create token */
    //var expiry = $form.find('[name=cardExpiry]').payment('cardExpiryVal');

    /*var ccData = {
        number: $form.find('[name=cardNumber]').val().replace(/\s/g, ''),
        cvc: $form.find('[name=cardCVC]').val(),
        exp_month: expiry.month,
        exp_year: expiry.year
    };*/

}

$(function () {

    var $form = $('#payment-form');
    
    stripe = Stripe(StripePublicKey);

    // Create stripe elements
    var elements = stripe.elements();
    cardNumberElement = elements.create('cardNumber');
    cardNumberElement.mount('#cardNumber');

    cardExpiryElement = elements.create('cardExpiry');
    cardExpiryElement.mount('#cardExpiry');

    cardCvcElement = elements.create('cardCvc');
    cardCvcElement.mount('#cardCVC');

    cardNumberElement.addEventListener('change', (event: any) => {
        let error = document.getElementById('cardNumberFeedback');
        console.log(error);
        if (event.error) {
            error.textContent = localizer["PaymentInvalidCardNumber"];
        } else {
            error.textContent = '';
        }
    });

    cardExpiryElement.addEventListener('change', (event: any) => {
        let error = document.getElementById('cardExpiryFeedback');
        console.log(error);
        if (event.error) {
            error.textContent = localizer["PaymentInvalidExpiry"];
        } else {
            error.textContent = '';
        }
    });

    cardCvcElement.addEventListener('change', (event: any) => {
        let error = document.getElementById('cardCVCFeedback');
        console.log(error);
        if (event.error) {
            error.textContent = localizer["PaymentInvalidCVC"];
        } else {
            error.textContent = '';
        }
    });
});

    /*
    // Fancy restrictive input formatting via jQuery.payment library
    $('input[name=cardNumber]').payment('formatCardNumber');
    $('input[name=cardCVC]').payment('formatCardCVC');
    $('input[name=cardExpiry]').payment('formatCardExpiry');

    // Form validation using Stripe client-side validation helpers
    (<any> jQuery).validator.addMethod("cardNumber", function (value, element) {
        return this.optional(element) || Stripe.card.validateCardNumber(value);
    }, localizer["PaymentInvalidCardNumber"]);

    (<any>jQuery).validator.addMethod("cardExpiry", function (value, element) {
        // Parsing month/year uses jQuery.payment library
        value = (<any>$).payment.cardExpiryVal(value);
        return this.optional(element) || Stripe.card.validateExpiry(value.month, value.year);
    }, localizer["PaymentInvalidExpiry"]);

    (<any>jQuery).validator.addMethod("cardCVC", function (value, element) {
        return this.optional(element) || Stripe.card.validateCVC(value);
    }, localizer["PaymentInvalidCVC"]);


*/